/**
 * Curated icon set for the go_to CTA icon picker. We deliberately expose
 * a small hand-picked list rather than the entire lucide-react catalogue
 * so the picker stays fast and admins don't get decision fatigue. Keys
 * are stored as strings in `cta{N}_icon` config; the ModularPage
 * renderer resolves the string back to a component via the same map.
 */
import {
  ArrowRight, ChevronRight, Check, Star, Heart, Home, Building2, Building,
  Phone, Mail, MapPin, Calendar, Clock, ShoppingBag, ShoppingCart, User, Users,
  Key, Wrench, Sparkles, TrendingUp, Award, Camera, Search, Send, PoundSterling,
  DollarSign, HandCoins, FileText, Info, HelpCircle, Wallet, Gift, Percent,
  Rocket, PlayCircle, Download, Upload,
} from "lucide-react";

// Ordered so the picker groups related concepts together (navigation →
// property → commerce → misc). `null` means "no icon" and is the default.
export const CTA_ICONS = {
  arrow_right: { label: "Arrow", Icon: ArrowRight },
  chevron_right: { label: "Chevron", Icon: ChevronRight },
  check: { label: "Check", Icon: Check },
  star: { label: "Star", Icon: Star },
  heart: { label: "Heart", Icon: Heart },
  sparkles: { label: "Sparkles", Icon: Sparkles },
  award: { label: "Award", Icon: Award },
  rocket: { label: "Rocket", Icon: Rocket },
  trending_up: { label: "Trending up", Icon: TrendingUp },
  play_circle: { label: "Play", Icon: PlayCircle },
  // Property
  home: { label: "Home", Icon: Home },
  building: { label: "Building", Icon: Building },
  building_2: { label: "Skyscraper", Icon: Building2 },
  key: { label: "Key", Icon: Key },
  map_pin: { label: "Location", Icon: MapPin },
  camera: { label: "Camera", Icon: Camera },
  wrench: { label: "Wrench", Icon: Wrench },
  // Commerce
  shopping_bag: { label: "Bag", Icon: ShoppingBag },
  shopping_cart: { label: "Cart", Icon: ShoppingCart },
  wallet: { label: "Wallet", Icon: Wallet },
  gift: { label: "Gift", Icon: Gift },
  percent: { label: "Percent", Icon: Percent },
  pound: { label: "£", Icon: PoundSterling },
  dollar: { label: "$", Icon: DollarSign },
  hand_coins: { label: "Coins", Icon: HandCoins },
  // Contact / meta
  phone: { label: "Phone", Icon: Phone },
  mail: { label: "Mail", Icon: Mail },
  send: { label: "Send", Icon: Send },
  user: { label: "User", Icon: User },
  users: { label: "Users", Icon: Users },
  calendar: { label: "Calendar", Icon: Calendar },
  clock: { label: "Clock", Icon: Clock },
  search: { label: "Search", Icon: Search },
  file_text: { label: "Document", Icon: FileText },
  info: { label: "Info", Icon: Info },
  help_circle: { label: "Help", Icon: HelpCircle },
  download: { label: "Download", Icon: Download },
  upload: { label: "Upload", Icon: Upload },
};

export function getCtaIcon(key) {
  if (!key) return null;
  return CTA_ICONS[key]?.Icon || null;
}
